<template>
    <section class="margin-both-lg container" :class="typeClass"  v-if="data">
        <template v-if="data.gravity_form_id && data.button_type && data.button_type === 'form'">
            <transition name="opacity" >
                <GravityFormPopup v-if="showForm" :title="data.form_title || ''" :content="data.form_description || ''" :form="Number(data.gravity_form_id)" @close="formIsClosed"/>
            </transition>
        </template>
        <a class="inner padding-lg" v-if="data.gravity_form_id && data.button_type && data.button_type === 'form'" @click="popGrafityForm" @mouseover="isHovered = true" @mouseout="isHovered = false" >
            <h2 class="titler">{{data.title}}</h2>
            <p class="description module-text margin-both" v-if="data.content" v-html="data.content"></p>
            <Button hasIcon iconType="link" :class="{'hover' : isHovered}" :aria-label="data.button_text" class="button-cta" :type="buttonType">
                <span v-html="data.button_text" />
            </Button>

        </a>

        <WpLink v-else :url="data.link.url" :title="data.link.title" :target="data.link.target"  @mouseover.native="isHovered = true" @mouseout.native="isHovered = false" class="inner padding-lg">
            <h2 class="titler">{{data.title}}</h2>
            <p class="description module-text margin-both" v-if="data.content" v-html="data.content"></p>
            <Button hasIcon iconType="link" :class="{'hover' : isHovered}" :aria-label="data.link.title" class="button-cta" :type="buttonType">
                <span v-html="data.link.title" />
            </Button>
        </WpLink>
    </section>
</template>

<script>
import Button from '@/components/elements/Button';
import WpLink from '@/components/elements/WpLink';
import GravityFormPopup from '@/components/parts/GravityFormPopup';

export default {
    name: 'call-to-action',
    props : ['data'],
    data(){
        return{
            isHovered: false,
            typeClass: 'white',
            showForm: false,
            allowReopenPopup: true,
        }
    },
    mounted(){
        this.fixColorClass()
    },
    components:{
        Button,
        WpLink,
        GravityFormPopup
    },
    computed:{
        buttonType(){
            let style = 'darkLight';
            if(this.typeClass === 'blue') style = 'white'
            
            return style
        }
    },
    methods:{
        fixColorClass(){
            const color = this.data.background_color
            if(!color) return;
            if(color == '#FFFFFF') this.typeClass = 'white';
            if(color == '#005782') this.typeClass = 'blue';
            if(color == '#BFD700') this.typeClass = 'green';
        },
        popGrafityForm(){
            if(this.allowReopenPopup){
                this.showForm = true;
                this.allowReopenPopup = false;
            }
        },
        formIsClosed(){
            this.showForm = false;
            setTimeout(()=>{
                this.allowReopenPopup = true
            }, 400)
        }

    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-call_to_action{
    text-align: center;
    .inner{
        border-radius: $blocksRadius;
        padding-left: 15px;
        padding-right: 15px;
        display: block;
        cursor: pointer;
        background-color: #fff;
        transition: 0.2s background ease-in-out, 0.2s color ease-in-out;
        text-decoration: none;
        .description{
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
            font-weight: 400;
            @include fluid-type($smallResText, $wideResText, 14px, 20px);
        }
        .button-cta{
            margin-top: 30px;
            @include mquery($tablet){
                margin-top: 20px;
            }
             @include mquery($phone){
                margin-top: 10px;
            }
        }
        .titler{
            margin-bottom: 20px;
            margin-top: 0;
        }
        &:hover{
            background-color: $darkLight;
            color: #fff;
            
        }
    }
    &.blue{
        .inner{
            color: #fff;
            background: $darkLight;
            &:hover{
                background-color: $dark;
            }
        }
    }
    &.green{
        .inner{
            color: $dark;
            background: $green;
            &:hover{
                background-color: white;
            }
        }
    }
}
</style>